import { useQuery } from '@apollo/client';
import * as _ from 'lodash-es';
import { useMemo } from 'react';
import { gql } from '../graphql/generated/gql';

const EXTERNAL_POSTS_QUERY = gql(/** @complexity 2 */ `
  query externalPostPlatforms {
    platforms: externalPostPlatforms {
      id
    }
  }
`);

const useExternalPostPlatforms = () => {
  const { data } = useQuery(EXTERNAL_POSTS_QUERY);
  return useMemo(() => _.compact(data?.platforms), [data]);
};

export default useExternalPostPlatforms;
